import React from 'react';

const ChevLeftIcon = ({ size = 14, ...props }) => (
  <svg
    width={Math.round((size * 12) / 18)}
    height={size}
    viewBox='0 0 12 18'
    fill='currentColor'
    {...props}>
    <path
      d='M 7.168 18 L 0 8.746 L 10.554 0 L 12 1.779 L 3.167 9.099 L 8.965 16.583 L 7.168 18 Z'
      fillRule='nonzero'
    />
  </svg>
);

export default ChevLeftIcon;
